module.exports = __webpack_public_path__ + "img/Flattop.6dfeebec.jpg";